import React from 'react';
import { StackProps } from './Stack.types';

const alignClasses = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
  stretch: 'items-stretch',
};

const justifyClasses = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
  around: 'justify-around',
};

const spacingClasses = {
  0: { vertical: 'space-y-0', horizontal: 'space-x-0' },
  1: { vertical: 'space-y-1', horizontal: 'space-x-1' },
  2: { vertical: 'space-y-2', horizontal: 'space-x-2' },
  3: { vertical: 'space-y-3', horizontal: 'space-x-3' },
  4: { vertical: 'space-y-4', horizontal: 'space-x-4' },
  6: { vertical: 'space-y-6', horizontal: 'space-x-6' },
  8: { vertical: 'space-y-8', horizontal: 'space-x-8' },
};

export const Stack: React.FC<StackProps> = ({
  children,
  className = '',
  direction = 'vertical',
  spacing = 4,
  align = 'start',
  justify = 'start',
}) => {
  const isVertical = direction === 'vertical';
  const spacingKey = spacing as keyof typeof spacingClasses;
  const spacingClass = spacingClasses[spacingKey]
    ? isVertical
      ? spacingClasses[spacingKey].vertical
      : spacingClasses[spacingKey].horizontal
    : '';

  return (
    <div
      className={`
        flex
        ${isVertical ? 'flex-col w-full' : 'flex-row'}
        ${spacingClass}
        ${alignClasses[align]}
        ${justifyClasses[justify]}
        ${className}
      `}
    >
      {children}
    </div>
  );
};
